export default {
  'SET_NOTIFICATION_HANDLERS'(state, data) {
    state.notificationHandlers = data;
  },
  'ADD_NOTIFICATION_HANDLER'(state, data) {
    state.notificationHandlers.push(data);
  },
  'DELETE_NOTIFICATION_HANDLER'(state, channel) {
    state.notificationHandlers = state.notificationHandlers.filter(item => {
      return item.channel !== channel;
    });
  },
  'SET_NOTIFICATION_CHANNELS'(state, data) {
    state.notificationChannels = data;
  }
};